import script from "./DepositIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./DepositIndex.vue?vue&type=script&setup=true&lang=ts"

import "./DepositIndex.vue?vue&type=style&index=0&id=603d72e0&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-603d72e0"]])

export default __exports__